/**
 * This panel is displayed when a project has no jobs in it.
 */
import React from 'react';

import DOC_URLS from '../../../util/doc_urls';
import {PublicJobsGettingStartedSection} from './PublicJobsGettingStartedSection';
import * as S from './ZeroJobs.styles';

export const ZeroJobs: React.FC<{}> = () => {
  return (
    <S.Panel>
      <S.OffsetUp>
        <S.Circle>
          <S.LightBulb />
        </S.Circle>
        <S.Heading>What are jobs?</S.Heading>
        <S.Message>
          Jobs are reusable, configurable run templates that allow you and your
          team to quickly launch new runs. Create your own project jobs or start
          with a public job.
        </S.Message>
        <S.FollowUpMessage>
          Learn more in
          <S.Link href={DOC_URLS.launchJobs}>Jobs documentation</S.Link>.
        </S.FollowUpMessage>
        <PublicJobsGettingStartedSection />
      </S.OffsetUp>
    </S.Panel>
  );
};
